import {launch} from '../modal';

export function launchOption(path: string, options: Object): void {
    launch('partials/auth/SignInPopUp', _.extend({ tab: path, cb: null }, options));
}

export function launchNotification(a: any): void {
    launch('partials/Dashboard/NotificationsPopup', { alerts: a });
}
